<template>
    <div>
        <b-row class="mb-2">
            <b-col class="text-left">
                <label>{{ usersLimit }}</label>
            </b-col>
            <b-col class="text-right">
                <b-button variant="primary" @click="validateUserLimit('SAVE')">
                    <font-awesome-icon icon="plus"></font-awesome-icon> Nuevo
                </b-button>
            </b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col sm="5" md="6" class="my-1">
                <b-input-group size="sm" prepend="Mostrar" append="registros">
                    <b-form-select v-model="users.itemsPerPage" id="perPageSelect" size="sm" :options="users.pageOptions"
                                   style="max-width: 5em"></b-form-select>
                </b-input-group>
            </b-col>

            <b-col sm="7" md="6" class="my-1">
                <b-input-group prepend="Filtrar: ">
                    <b-input v-model="users.filter" debounce="300"></b-input>
                </b-input-group>
            </b-col>
        </b-row>
        <b-table :items="loadData" :fields="users.fields" :filter="users.filter" :current-page="users.currentPage"
                 :per-page="users.itemsPerPage" empty-text="Sin registros" empty-filtered-text="Sin coincidencias"
                 striped bordered hover small show-empty :responsive="true"  :sort-by.sync="users.sortBy" ref="usersTable"
                 class="text-left">
            <template v-slot:thead-top>
                <b-tr>
                    <b-th v-for="(field, index) in users.fields" :key="field.key">
                        <b-row v-if="users.filters[index]">
                            <b-col v-if="users.filters[index].inputType === 'Select'">
                                <b-select v-model="users.filters[index].value">
                                    <b-select-option value="">Todos</b-select-option>
                                    <b-select-option value="TRUE">Activo</b-select-option>
                                    <b-select-option value="FALSE">Inactivo</b-select-option>
                                </b-select>
                            </b-col>
                            <b-col v-else-if="users.filters[index].type === 'STRING'">
                                <b-input :placeholder="field.label" v-model="users.filters[index].value" debounce="300"></b-input>
                            </b-col>
                        </b-row>
                    </b-th>
                </b-tr>
            </template>

            <template v-slot:cell(enabled)="row">
                <b-badge variant="primary" v-if="row.item.enabled" class="p-1">Activo</b-badge>
                <b-badge variant="warning" v-else>Inactivo</b-badge>
            </template>

            <template v-slot:cell(actions)="row">
                <b-button-group size="sm">
                    <b-button :to="editUserRoute(row.item.id)" v-b-tooltip.hover
                              title="Modificar" variant="outline-primary">
                        <font-awesome-icon icon="edit"></font-awesome-icon>
                    </b-button>
                    <b-button v-b-tooltip.hover :title="row.item.enabled ? 'Desactivar' : 'Activar'"
                              variant="outline-primary" @click="validateUserLimit('CHANGE_STATUS', row.item)">
                        <font-awesome-icon :icon="row.item.enabled ? 'toggle-off' : 'toggle-on'"></font-awesome-icon>
                    </b-button>
                </b-button-group>
            </template>

            <template v-slot:table-caption>
                <b-row class="no-gutters">
                    <b-col sm="5" md="6">
                        Mostrando {{ start }} a {{ end }} de {{ users.totalRows }} registro<template v-if="users.totalRows !== 1">s</template>
                    </b-col>
                    <b-col sm="7" md="6" class="my-1">
                        <b-pagination v-model="users.currentPage" :total-rows="users.totalRows"
                                      :per-page="users.itemsPerPage" align="fill" size="sm" class="my-0"></b-pagination>
                    </b-col>
                </b-row>
            </template>
        </b-table>
    </div>
</template>

<script>
import { userListUrl, userEnableUrl, validateUserLimit } from '@routes';
import * as constants from '@constants';

export default {
    props: {
        settings: Object,
        customer: Object,
        membership: Object,
        userType: String
    },
    data() {
        return {
            users: {
                fields: [
                    // { key: 'id', label: 'id', sortable: true },
                    { key: 'name', label: 'Nombre', sortable: true },
                    { key: 'username', label: 'Usuario', sortable: true },
                    { key: 'email', label: 'Correo', sortable: true },
                    { key: 'phone1', label: 'Teléfono 1', sortable: true },
                    { key: 'phone2', label: 'Teléfono 2', sortable: true },
                    { key: 'jobPosition', label: 'Puesto', sortable: true },
                    { key: 'enabled', label: 'Estatus', sortable: true, class: 'text-center' },
                    { key: 'actions', label: 'Acciones', class: 'text-center' }
                ],
                filters: [
                    { column: 'u.name', type: 'STRING', value: '', format: '' },
                    { column: 'u.username', type: 'STRING', value: '', format: '' },
                    { column: 'u.email', type: 'STRING', value: '', format: '' },
                    { column: 'u.phone1', type: 'STRING', value: '', format: '' },
                    { column: 'u.phone2', type: 'STRING', value: '', format: '' },
                    { column: 'u.job_position', type: 'STRING', value: '', format: '' },
                    { column: 'u.enabled', type: 'BOOLEAN', value: '', format: '', inputType: 'Select' }
                ],
                filter: '',
                isLoading: false,
                pageOptions: [25, 50, 75, 100],
                totalRows: 0,
                currentPage: 1,
                itemsPerPage: 25,
                sortBy: 'u.id',
                sortDesc: false
            }
        }
    },
    methods: {
        loadData(ctx) {
            if (ctx.sortBy !== '') {
                let data = {
                    filters: this.users.filters.filter(filter => filter.value.trim() !== ''),
                    application: this.userType,
                    ...ctx
                };

                data.currentPage = (data.currentPage - 1) * data.perPage;

                if (this.userType === constants.PORTAL_USER) {
                    data.customerId = this.customer.id;
                }

                if (!('customerId' in data) || data.customerId > 0) {
                    return this.axios.post(userListUrl(), data).then(response => {
                        if (response.data.code === constants.CODE_OK) {
                            this.users.totalRows = response.data.totalRows;
                            return response.data.users;
                        } else {
                            return [];
                        }
                    }).catch(error => {
                        console.error(error);

                        return [];
                    });
                } else {
                    return Promise.resolve([]);
                }
            }
        },
        changeStatus(user) {
            this.$swal({
                title: `¿${user.enabled ? 'Desactivar' : 'Activar'} al usuario ${user.name}?`,
                icon: 'question'
            }).then(result => {
                if (result.value) {
                    this.axios.put(userEnableUrl(), {
                        application: this.userType,
                        userId: user.id,
                        enable: !user.enabled
                    }).then(response => {
                        if (response.data.code === constants.CODE_OK) {
                            user.enabled = !user.enabled;

                            this.$bvToast.toast(response.data.message, {
                                title: this.userType === constants.BACK_OFFICE_USER ? 'Usuarios backoffice' : 'Usuarios finales',
                                variant: 'success'
                            });

                            this.$refs.usersTable.refresh();
                            this.$emit('get-setting');
                        }
                    }).catch(() => {
                        this.$bvToast.toast('Ocurrió un error al guardar la configuración.', {
                            title: this.userType === constants.BACK_OFFICE_USER ? 'Usuarios backoffice' : 'Usuarios finales',
                            variant: 'danger'
                        });
                    });
                }
            });
        },
        editUserRoute(id) {
            if (this.userType === constants.BACK_OFFICE_USER) {
                return { name: 'UserEdit', params: { id }};
            } else {
                return { name: 'PortalUserEdit', params: { id, customerId: this.customer.id }};
            }
        },
        validateUserLimit(action, user) {
            let data = {
                params: {
                    application: this.userType,
                    action: action
                }
            };

            if (action === 'CHANGE_STATUS') {
                data.params.enabled = !user.enabled;
            }

            this.axios.get(validateUserLimit(), data).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    if (action === 'CHANGE_STATUS') {
                        this.changeStatus(user);
                    } else {
                        this.$router.push(this.newUserRoute);
                    }
                } else {
                    this.$swal({
                        title: response.data.message,
                        icon: 'error',
                        showCancelButton: false,
                        confirmButtonText: 'Entendido'
                    });
                }
            });
        }
    },
    watch: {
        'customer.id'() {
            this.$refs.usersTable.refresh();
        },
        'users.filters': {
            handler() {
                this.$refs.usersTable.refresh();
            },
            deep: true
        }
    },
    computed: {
        newUserRoute() {
            if (this.userType === constants.BACK_OFFICE_USER) {
                return { name: 'UserNew' };
            } else {
                return { name: 'PortalUserNew', params: { customerId: this.customer.id }};
            }
        },
        usersLimit() {
            let limit = `Límite de administradores: ${this.membership.userLimit}`;

            if (this.userType === constants.PORTAL_USER) {
                limit = `Límite de usuarios: ${this.membership.portalUserLimit}`;
            }

            return limit;
        },
        start: function() {
            return this.users.totalRows === 0 ? 0 : (this.users.currentPage - 1) * this.users.itemsPerPage + 1;
        },
        end: function() {
            let offset = (this.users.currentPage - 1) * this.users.itemsPerPage;

            return (this.users.totalRows - offset) < this.users.itemsPerPage ? this.users.totalRows : offset + this.users.itemsPerPage;
        }
    }
}
</script>

<style scoped>

</style>